import React, { useState, useEffect } from "react";
import { Drawer, Form, InputNumber, Button, Row, Col, Divider, Typography, Select, Space } from "antd";
import { connect } from "react-redux";
import { updateInvoice } from "../../actions/invoiceItem";
import { getAllAccount } from "../../actions/accountsAction";

const { Title, Text } = Typography;
const { Option } = Select;

const UpdatePayment = ({ invoice, updateInvoice, getAllAccount, onUpdateSuccess }) => {
  const [visible, setVisible] = useState(false);
  const [form] = Form.useForm();
  const [dueAmount, setDueAmount] = useState(0);
  const [accounts, setAccounts] = useState([]);

  useEffect(() => {
    if (invoice) {
      setDueAmount(invoice.due);
    }
  }, [invoice]);

  useEffect(() => {
    if (visible) {
      getAllAccount().then((res) => {
        if (res) setAccounts(res);
      });
    }
  }, [visible, getAllAccount]);

  const showDrawer = () => {
    setVisible(true);
    form.setFieldsValue({
      payment: invoice.payment,
      account: invoice.account,
    });
    setDueAmount(invoice.due);
  };

  const onClose = () => {
    setVisible(false);
  };

  const handleValuesChange = (changedValues, allValues) => {
    if (changedValues.payment !== undefined) {
      const newPayment = changedValues.payment || 0;
      const newDue = (invoice.bill || 0) - newPayment;
      setDueAmount(newDue > 0 ? newDue : 0);
    }
  };

  const onFinish = (values) => {
    let paymentMethod = invoice.Payment_method;
    if (values.account) {
      const selectedAccount = accounts.find(acc => acc.id === values.account);
      if (selectedAccount) {
        paymentMethod = selectedAccount.type === "Cash" ? "Cash" : selectedAccount.name;
      }
    }

    updateInvoice(invoice.id, {
      payment: values.payment,
      due: (invoice.bill || 0) - values.payment > 0 ? (invoice.bill || 0) - values.payment : 0,
      advance_payment: values.payment - (invoice.bill || 0) > 0 ? values.payment - (invoice.bill || 0) : 0,
      account: values.account,
      Payment_method: paymentMethod
    }).then((res) => {
      if (res) {
        setVisible(false);
        if (onUpdateSuccess) onUpdateSuccess();
        window.location.reload();
      }
    });
  };

  return (
    <>
      <Button type="primary" size="small" onClick={showDrawer}>
        Update Payment
      </Button>
      <Drawer
        title={`Update Payment - Invoice #${invoice.invoice_number}`}
        width={600}
        onClose={onClose}
        visible={visible}
        bodyStyle={{ paddingBottom: 80 }}
      >
        <Form
          form={form}
          layout="vertical"
          onFinish={onFinish}
          onValuesChange={handleValuesChange}
          initialValues={{ payment: invoice.payment, account: invoice.account }}
        >
          <Row gutter={16}>
            <Col span={24}>
              <div style={{ background: "#f0f2f5", padding: "16px", borderRadius: "8px", marginBottom: "24px" }}>
                <Row justify="space-between">
                  <Text type="secondary">Total Bill:</Text>
                  <Text strong>{invoice.bill} BDT</Text>
                </Row>
                <Row justify="space-between" style={{ marginTop: "8px" }}>
                  <Text type="secondary">Already Paid:</Text>
                  <Text>{invoice.payment} BDT</Text>
                </Row>
                <Divider style={{ margin: "12px 0" }} />
                <Row justify="space-between">
                  <Title level={5} style={{ margin: 0 }}>Current Due:</Title>
                  <Title level={5} style={{ margin: 0, color: dueAmount > 0 ? "#ff4d4f" : "#52c41a" }}>
                    {dueAmount} BDT
                  </Title>
                </Row>
              </div>
            </Col>
          </Row>

          <Form.Item
            name="payment"
            label="Total Paid Amount"
            rules={[{ required: true, message: "Please enter paid amount" }]}
          >
            <InputNumber
              style={{ width: "100%" }}
              min={0}
              placeholder="Enter new total payment"
            />
          </Form.Item>

          <Form.Item
            name="account"
            label="Payment Method / Account"
            rules={[{ required: true, message: "Please select an account" }]}
          >
            <Select placeholder="Select Account">
              {accounts.map((acc) => (
                <Option key={acc.id} value={acc.id}>
                  {acc.name} ({acc.type})
                </Option>
              ))}
            </Select>
          </Form.Item>

          <div
            style={{
              position: "absolute",
              right: 0,
              bottom: 0,
              width: "100%",
              borderTop: "1px solid #e9e9e9",
              padding: "10px 16px",
              background: "#fff",
              textAlign: "right",
            }}
          >
            <Space>
              <Button onClick={onClose}>Cancel</Button>
              <Button type="primary" htmlType="submit">
                Update
              </Button>
            </Space>
          </div>
        </Form>
      </Drawer>
    </>
  );
};

export default connect(null, { updateInvoice, getAllAccount })(UpdatePayment);
